import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { LocationViewModel, LocationProductQualification } from "../../../../shared/models/locations/LocationViewModel.model";

@Component({
  selector: "app-location-qualifications-tab",
  templateUrl: "./location-qualifications-tab.component.html",
  styleUrls: ["./location-qualifications-tab.component.css"],
})
export class LocationQualificationsTabComponent implements OnInit, OnChanges {
  @Input() location: LocationViewModel;
  @Input() isEditMode: boolean;
  @Input() productQualificationsList: any[];
  @Input() loadingProductQualifications: boolean = false;

  @Output() hasChanges = new EventEmitter<boolean>();

  allProductQualifications: any[] = [];
  selectedProductQualificationIds: Set<string> = new Set();
  private originalLocation: string;

  constructor() {}

  ngOnInit() {
    this.originalLocation = JSON.stringify(this.location);
    this.initializeProductQualifications();
    this.initializeSelectedProductQualifications();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["location"] && !changes["location"].firstChange) {
      this.originalLocation = JSON.stringify(this.location);
      this.initializeSelectedProductQualifications();
      this.checkForChanges();
    }
    if (changes["productQualificationsList"]) {
      this.initializeProductQualifications();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  private checkForChanges() {
    const currentLocation = JSON.stringify(this.location);
    const changed = currentLocation !== this.originalLocation;
    this.hasChanges.emit(changed);
  }

  initializeProductQualifications() {
    if (this.productQualificationsList && this.productQualificationsList.length > 0) {
      this.allProductQualifications = [...this.productQualificationsList];
    } else {
      this.allProductQualifications = [];
    }
  }

  initializeSelectedProductQualifications() {
    if (this.location?.productQualifications && Array.isArray(this.location.productQualifications)) {
      this.selectedProductQualificationIds = new Set(
        this.location.productQualifications
          .filter((pq: LocationProductQualification) => pq.productQualificationId)
          .map((pq: LocationProductQualification) => pq.productQualificationId)
      );
    } else {
      this.selectedProductQualificationIds = new Set();
    }
  }

  isProductQualificationSelected(productQualificationId: string): boolean {
    return this.selectedProductQualificationIds.has(productQualificationId);
  }

  toggleProductQualification(productQualification: any) {
    if (this.selectedProductQualificationIds.has(productQualification.id)) {
      this.selectedProductQualificationIds.delete(productQualification.id);
      this.location.productQualifications =
        this.location.productQualifications?.filter(
          (pq: LocationProductQualification) => pq.productQualificationId !== productQualification.id
        ) || [];
    } else {
      this.selectedProductQualificationIds.add(productQualification.id);
      if (!this.location.productQualifications) {
        this.location.productQualifications = [];
      }
      this.location.productQualifications.push({
        locationId: this.location.id,
        productQualificationId: productQualification.id,
        productQualificationName: productQualification.name,
        productQualificationAvatarFieldName: productQualification.avatarFieldName,
      });
    }
    this.onFieldChange();
  }

  trackByProductQualificationId(index: number, productQualification: any): string {
    return productQualification.id;
  }
}

